import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
// import EventListener from "react-event-listener";
// import { getTouchEvent } from "../common/Utils";
import { TooltipProps } from "./PropsType";

export default function Tooltip(props: TooltipProps) {
  const tooltip = useRef(null);
  const er = useRef(null);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  //   let touchEvent: any = getTouchEvent();
  const [data, setData] = useState({
    tooltipStyle: {},
    open: false,
  });
  const { open, tooltipStyle = {} } = data;

  const {
    children,
    className,
    delay = 0,
    dir = "bottom",
    title = "",
    prefixCls = "bm-Tooltip",
    ...other
  } = props;
  const styleClass = classNames(
    `${prefixCls}-content`,
    `${prefixCls}-${dir}`,
    open && `${prefixCls}-active`
  );
  const groupStyle = classNames(prefixCls, className);
  const close = () => {
    setData({
      ...data,
      open: false,
    });
    if (props.onClose) {
      props.onClose();
    }
  };

  const show = () => {
    setData({
      ...data,
      open: true,
    });
    if (props.onOpen) {
      props.onOpen();
    }
  };

  const updateTooltipState = () => {
    if (tooltip.current && er.current) {
      const elem: any = er.current;
      const rect = elem.getBoundingClientRect();
      if (!elem.style.position) {
        elem.style.position = "relative";
      }
      let top =
        rect.height / 2 - (tooltip.current as HTMLDivElement).offsetHeight / 2;
      let left =
        rect.width / 2 - (tooltip.current as HTMLDivElement).offsetWidth / 2;
      switch (dir) {
        case "left":
          left = -(tooltip.current as HTMLDivElement).offsetWidth;
          break;
        case "right":
          left = rect.width;
          break;
        case "top":
          top = -(tooltip.current as HTMLDivElement).offsetHeight;
          break;
        case "bottom":
          top = rect.height;
          break;
      }
      setData({
        ...data,
        tooltipStyle: { top, left },
      });
    }
  };

  const handleTouchStart = () => {
    if (!open) {
      if (timeoutId.current) {
        close();
        clearTimeout(timeoutId.current);
      }
      show();
    } else {
      handleTouchEnd();
    }
  };

  const handleTouchEnd = () => {
    timeoutId.current = setTimeout(() => {
      close();
      timeoutId.current = null;
    }, props.delay);
  };

  // const handleResize = () => {
  //   // touchEvent = getTouchEvent();
  //   updateTooltipState();
  // };

  const handleWindowResize = () => {
    updateTooltipState();
  };

  useEffect(() => {
    updateTooltipState();

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    }
  }, []);

  return (
    // <EventListener target="window" onResize={handleResize}>
      <div ref={er} className={groupStyle} onClick={handleTouchStart}>
        {children}
        <div
          className={styleClass}
          {...other}
          ref={tooltip}
          style={tooltipStyle}
        >
          {title}
        </div>
      </div>
    // </EventListener>
  );
}
